<div class="profile-top-outer py-5" id="tab12" [style.background-color]="bannerColor">
  <div class="profile-top-inner py-5">
    <div class="min-height-250 d-sm-flex text-center text-sm-start align-items-center justify-content-sm-start">
      <div class="profile-img position-relative pe-sm-4 pb-4 pb-sm-0" *ngIf="imgURL != ''">
        <div class="profile-upload-output">
          <img
            loading="lazy"
            [src]="imgURL"
            [attr.data-bs-toggle]="editable ? 'modal' : null"
            [attr.data-bs-target]="editable ? '#ImagePost' : null"
            (click)="editable && onUploadClick()"
            style="border-radius: 50% !important; object-fit: cover !important;"
          />
        </div>
        <div class="profile-upload-btn mt-3" *ngIf="editable">
          <button
            class="btn"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#ImagePost"
            (click)="onUploadClick()"
          >
            <span [translate]="'GREATER.UPLOAD'"> </span>
          </button>
        </div>
      </div>

      <div class="profile-top-info ps-sm-3">
        <div class="d-flex align-items-center justify-content-center justify-content-sm-start">
          <h2 class="title text-capitalize pe-4 m-0">
            {{ displayName }}
          </h2>
          <button
            *ngIf="!editable"
            class="ps-3 tooltip-btn"
            type="button"
            matTooltip="Edit"
          >
            <a href="javascript:void(0);" class="profile-edit-btn" routerLink="/edit-profile">
              <svg width="15" height="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.9266 1.21182C13.608 0.893613 13.1761 0.714844 12.7258 0.714844C12.2755 0.714844 11.8435 0.89361 11.5249 1.21182L3.11604 9.62695L5.51922 12.0316L13.9265 3.62274C14.2479 3.30401 14.4286 2.87004 14.4286 2.41739C14.4286 1.96474 14.2479 1.53076 13.9265 1.21204L13.9266 1.21182ZM0.714355 14.4347L4.31851 13.2323L1.91523 10.8291L0.714355 14.4347Z"/>
              </svg>
            </a>
          </button>
        </div>
        <p class="profile-creator-types mb-0 pt-2" *ngIf="creatorTypeLabel">
          {{ creatorTypeLabel }}
        </p>
        <div class="d-flex align-items-center justify-content-center justify-content-sm-start pt-2">
          <p class="center-dot">.</p>
          <p *ngIf="currentDetail.user_role_type == 3">Individual Creator</p>
          <p *ngIf="currentDetail.user_role_type == 2">Organisation</p>
        </div>
      </div>
    </div>
  </div>
</div>
